import format from 'date-fns/format';
import isExists from 'date-fns/isExists';
import isValid from 'date-fns/isValid';

export const splitDateIntoArr = (date = null) => {
  if (!date) return [];

  const dateArr = date.split('-').map(item => parseInt(item));

  return [
    dateArr[0],
    ...(dateArr[1] ? [dateArr[1] - 1] : []),
    ...dateArr.slice(2),
  ];
};

export const isValidDate = date => {
  if (typeof date === 'string' && date !== 'incomplete') {
    let formattedDate = splitDateIntoArr(date);

    if (formattedDate.length >= 1) {
      const extendedDateForExistence = [
        ...formattedDate,
        ...Array(3 - formattedDate.length).fill(1),
      ];

      if (isExists(...extendedDateForExistence)) {
        const dateObj = new Date(...formattedDate);

        return isValid(dateObj);
      }
    }
  }

  return false;
};

export const formatDate = (date, dateFormat = 'MMMM yyyy') => {
  if (!isValidDate(date)) return '';

  const dateObj = new Date(...splitDateIntoArr(date));

  return format(dateObj, dateFormat);
};
